<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  updated: function () {
    this.$nextTick(() => {
      this.$emit('change')
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue